import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line

import AnimationRevealPage from "../helpers/AnimationRevealPage";
import MainFeature from "components/features/TwoColWithButton";
import Footer from "components/footers/FiveColumnWithBackground";
import Header from "../components/headers/light";

import educationalInstitutePageSrc from "images/educational-institute-page.png";

export default function EducationalInstitutes() {
  const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;

  return (
    <AnimationRevealPage disabled>
      <Header />
      <MainFeature
        subheading={<Subheading>Educación</Subheading>}
        heading={
          <>
            Instituciones <span tw="text-primary-500">Educativas.</span>
          </>
        }
        imageSrc={educationalInstitutePageSrc}
        imageBorder={false}
        imageDecoratorBlob={true}
        withoutButton={true}
        showDescriptions={true}
        descriptions={[
          "Si planeas usar ADA como herramienta para tus cursos educativos dentro de tu institución llegaste al lugar correcto!",
          "Tendrás que ponerte en contacto con nosotros para que podamos aprobar tu institución educativa y darla de alta en el sistema. Podes escribirnos a proy.ing.sw@gmail.com que con gusto estaremos respondiendo y dándote soporte.",
          "Adicionalmente vamos a necesitar un mail de un usuario de ADA. Este usuario será el administrador de su instituto, lo que quiere decir que será el/ella quien acepte a otros docentes para que puedan crear contenido dentro de su instituto. De esta forma evitamos que usuarios ajenos a su institución den de alta material inadecuado.",
          "El quipo de ADA continúa trabajando continuamente en la aplicación, por lo que seguramente pronto tendremos mayor información para darte!"
        ]}
      />
      <Footer />
    </AnimationRevealPage>
  );
}
